module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="c-jauge-inner" title="">\r\n    <div class="c-jauge-inner__content"></div>\r\n</div>\r\n<div class="c-jauge__circle__break">\r\n    <span class="c-jauge__circle__break__text"></span>\r\n</div>';
}
return __p;
};
